import React from "react";
import { Outlet } from "react-router-dom";
import CssBaseline from "@mui/material/CssBaseline";
import AppNavbar from "./AppNavbar";

function Layout() {
  return (
    <div className="layout-container">
      <CssBaseline />
      {/* <AppNavbar /> */}
      <main >
        <Outlet />
      </main>
    </div>
  );
}

export default Layout;
